import React from "react";
import FileTypeIcon from "./FileTypeIcon";
import { TrashIcon } from "@heroicons/react/24/outline";

function bytesToMB(bytes) {
  const mb = bytes / (1024 * 1024);
  return mb.toFixed(2);
}

const FilesRows = ({ files = [], onRemove = () => {} }) => {
  return (
    <div className="flex flex-col gap-4">
      {files.map((file, idx) => (
        <div
          key={idx}
          className="p-4 rounded-xl border flex items-center gap-4 justify-between"
        >
          <div className="flex items-center gap-4">
            <FileTypeIcon type={file.type} />
            <div className="flex flex-col gap-1">
              <span className="font-semibold text-xs text-gray-600">
                {file.name}
              </span>
              <span className="text-xs text-gray-400">
                {bytesToMB(file.size)} MB
              </span>
            </div>
          </div>
          <button type="button" onClick={() => onRemove(idx)}>
            <TrashIcon className="size-4 text-gray-500 hover:text-gray-600" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default FilesRows;
